"use strict";
var appn;
(function (appn) {
    var ui;
    (function (ui) {
        ui.colorPalette = new appn.utils.ColorPalette();
        function getMainContentForm() {
            const appnForm = $('form#appnForm');
            if (appn.utils.hasValue(appnForm))
                return appnForm;
            return $('section.content form:first');
        }
        ui.getMainContentForm = getMainContentForm;
        function handleParentResize(timeOut = 0, addHeightValue = 0) {
            var $parentiFrame = parent.document.getElementById('e-modal-iframe');
            setTimeout(function () {
                if ($parentiFrame === null)
                    return;
                $parentiFrame.style.height = 'auto';
                $parentiFrame.style.height = document.documentElement.scrollHeight + addHeightValue + 'px';
            }, timeOut);
        }
        ui.handleParentResize = handleParentResize;
        function designerAreaCheck() {
            var _a, _b, _c;
            const designerMain = (_a = window.appn.designer) === null || _a === void 0 ? void 0 : _a.main;
            if (designerMain) {
                return { isDesigner: true, type: designerMain.screenType };
            }
            const syncDesigner = (_c = (_b = window.sync) === null || _b === void 0 ? void 0 : _b.syncs) === null || _c === void 0 ? void 0 : _c.SyncDesigner;
            if (syncDesigner) {
                return { isDesigner: true, type: undefined, isSync: true };
            }
            return { isDesigner: false, type: undefined };
        }
        ui.designerAreaCheck = designerAreaCheck;
        function cardExpand(card) {
            if (!appn.utils.hasValue(card))
                return;
            card.CardWidget('expand');
        }
        ui.cardExpand = cardExpand;
        function cardCollapse(card) {
            if (!appn.utils.hasValue(card))
                return;
            card.CardWidget('collapse');
        }
        ui.cardCollapse = cardCollapse;
        function cardToggle(card) {
            if (!appn.utils.hasValue(card))
                return;
            card.CardWidget('toggle');
        }
        ui.cardToggle = cardToggle;
        function tryResetFiltersEvent() {
            $('.link-reset-filters').on('click', function (e) {
                e.preventDefault();
                $('.btn-resetFilters').click();
            });
        }
        ui.tryResetFiltersEvent = tryResetFiltersEvent;
        function abbreviateNumbers() {
            $('.appn-num-abbr').each(function (index, numberElement) {
                const suffixes = [appn.emptyString, 'k', 'm', 'b', 't'];
                const innerText = numberElement.innerText;
                if (isNaN(innerText))
                    return;
                const originalNumber = innerText;
                if (originalNumber < 10000)
                    return;
                let result = originalNumber;
                let suffixNum = Math.floor(String(originalNumber).length / 3);
                if (suffixNum !== 0) {
                    result = originalNumber / Math.pow(1000, suffixNum);
                    if (String(result).contains('.') && String(result).substr(0, String(result).indexOf('.')) === '0') {
                        result = Math.round((result * 1000));
                        suffixNum--;
                    }
                }
                if (result % 1 !== 0)
                    result = Number(result.toFixed(1));
                numberElement.setAttribute('title', String(originalNumber));
                numberElement.innerText = result + suffixes[suffixNum];
            });
        }
        ui.abbreviateNumbers = abbreviateNumbers;
        function popup(mylink) {
            if (!window.focus)
                return true;
            let href;
            if (typeof mylink === 'string')
                href = mylink;
            else if (mylink.href)
                href = mylink.href;
            else
                href = $(mylink).data('src');
            window.open(href, 'popup', 'width=960,height=600,resizable=yes,scrollbars=yes');
            return false;
        }
        ui.popup = popup;
        function initOpenOnClick() {
            $('.open-onclick, .fileinput .fileinput-new.thumbnail img').off().on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                appn.dialog.viewMediaFromElement($(this));
            });
        }
        ui.initOpenOnClick = initOpenOnClick;
        function toggleEnabledOrDisabled($elementToToggle) {
            if (isElementDisabled($elementToToggle))
                enableElement($elementToToggle);
            else
                disableElement($elementToToggle);
        }
        ui.toggleEnabledOrDisabled = toggleEnabledOrDisabled;
        function isElementDisabled($elementToCheck) {
            return $elementToCheck.is('[disabled]') || $elementToCheck.hasClass('disabled');
        }
        ui.isElementDisabled = isElementDisabled;
        function enableElement($elementToEnable) {
            $elementToEnable.removeClass('disabled').removeAttr('disabled');
            return $elementToEnable;
        }
        ui.enableElement = enableElement;
        function disableElement($elementToDisable) {
            $elementToDisable.addClass('disabled').attr('disabled', 'disabled');
            return $elementToDisable;
        }
        ui.disableElement = disableElement;
        function enableDisableIfPopulated($elementToWatch, $elementToToggle, invert) {
            $elementToWatch.on('input', function (e) {
                if ($elementToWatch.val().length > 0) {
                    if (invert)
                        disableElement($elementToToggle);
                    else
                        enableElement($elementToToggle);
                    return;
                }
                if (invert)
                    enableElement($elementToToggle);
                else
                    disableElement($elementToToggle);
            });
            if ($elementToWatch.val().length < 1)
                if (invert)
                    enableElement($elementToToggle);
                else
                    disableElement($elementToToggle);
        }
        ui.enableDisableIfPopulated = enableDisableIfPopulated;
        function showExportConfirmation(entityName) {
            entityName = T('{0} Export', entityName ? entityName : '').trim();
            const title = T('<b>{0} scheduled</b>', entityName).toUpperCase();
            appn.toast.notify(appn.toast.Type.info, T(`{0}#TITLE#Check your <a class='cursor-pointer' data-notifications-launch='{1}'>notifications</a> for progress and downloads.`, title, appn.urls.notifications.index));
        }
        ui.showExportConfirmation = showExportConfirmation;
        function showImportConfirmation(entityName) {
            entityName = T('{0} Import', entityName ? entityName : '').trim();
            const title = T('<b>{0} scheduled</b>', entityName).toUpperCase();
            appn.toast.notify(appn.toast.Type.info, T(`{0}#TITLE#Check your <a class='cursor-pointer' data-notifications-launch='{1}'>notifications</a> for progress.`, title, appn.urls.notifications.index));
        }
        ui.showImportConfirmation = showImportConfirmation;
        function initDateAndTimePickers() {
            datePicker($('.datepicker'));
            timePicker($('.timepicker'));
            dateTimePicker($('.datetimepicker'));
            addDTEvents();
        }
        ui.initDateAndTimePickers = initDateAndTimePickers;
        function addDTEvents() {
            $(document).on('dp.show dp.hide', '.datepicker', function () {
                resizeAndScrollTo($(this));
            });
            $(document).on('dp.show dp.hide', '.timepicker', function () {
                resizeAndScrollTo($(this));
            });
            $(document).on('dp.show dp.hide', '.datetimepicker', function () {
                resizeAndScrollTo($(this));
            });
        }
        function resizeAndScrollTo(inputElement) {
            handleParentResize(0, 15);
            setTimeout(function () {
                inputElement[0].scrollIntoView({
                    behavior: "auto",
                    block: "center"
                });
            }, 5);
        }
        function datePicker($selector, afterChangedCallback, format) {
            createAndPositionDatePicker($selector, format ? format : 'DD-MMM-YYYY', afterChangedCallback);
        }
        ui.datePicker = datePicker;
        function timePicker($selector, afterChangedCallback) {
            createAndPositionDatePicker($selector, 'HH:mm', afterChangedCallback);
        }
        ui.timePicker = timePicker;
        function dateTimePicker($selector, afterChangedCallback, format) {
            createAndPositionDatePicker($selector, format !== null && format !== void 0 ? format : 'DD-MMM-YYYY HH:mm', afterChangedCallback);
        }
        ui.dateTimePicker = dateTimePicker;
        function createAndPositionDatePicker($selector, inputFormat, afterChangedCallback) {
            const $dp = $selector.datetimepicker({
                allowInputToggle: true,
                locale: 'en',
                format: inputFormat,
                sideBySide: true,
                keyBinds: { t: null }
            });
            $dp.on('dp.show', function () {
                var _a;
                const datepicker = $('body').find('.bootstrap-datetimepicker-widget:last'), position = datepicker.offset(), parent = datepicker.parent(), parentPos = parent.offset(), width = datepicker.width(), parentWid = parent.width();
                datepicker.appendTo('body');
                datepicker.css({
                    position: 'absolute',
                    top: position ? position.top : 0,
                    bottom: 'auto',
                    left: position ? position.left : 0,
                    right: 'auto'
                });
                if (parentPos.left + parentWid < position.left + width) {
                    let newLeft = parentPos.left;
                    newLeft += parentWid / 2;
                    newLeft -= width / 2;
                    datepicker.css({ left: newLeft });
                }
                if ((_a = $selector.attr('class')) === null || _a === void 0 ? void 0 : _a.containsIgnoreCase('datetime')) {
                    datepicker.addClass('loaded');
                }
            });
            $dp.on('dp.change', function () {
                if (afterChangedCallback)
                    afterChangedCallback();
            });
        }
        function changeIconColor(iconElement, color, imgWidth, imgHeight, alpha) {
            const canvas = document.createElement('canvas'), context = canvas.getContext('2d');
            const desaturate = function () {
                const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                const pixels = imageData.data;
                let i, l, r, g, b, a, average;
                for (i = 0, l = pixels.length; i < l; i += 4) {
                    a = pixels[i + 3];
                    if (a === 0)
                        continue;
                    r = pixels[i];
                    g = pixels[i + 1];
                    b = pixels[i + 2];
                    average = (r + g + b) / 3 >>> 0;
                    pixels[i] = pixels[i + 1] = pixels[i + 2] = average;
                }
                context.putImageData(imageData, 0, 0);
            };
            const colorize = function (color, alpha) {
                context.globalCompositeOperation = 'source-atop';
                context.globalAlpha = alpha;
                context.fillStyle = color;
                context.fillRect(0, 0, canvas.width, canvas.height);
                context.globalCompositeOperation = 'source-over';
                context.globalAlpha = 1.0;
            };
            if (color === 'transparent' || color === appn.emptyString)
                return iconElement.src;
            canvas.width = imgWidth;
            canvas.height = imgHeight;
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(iconElement, 0, 0, canvas.width, canvas.height);
            desaturate();
            colorize(color, alpha);
            return canvas.toDataURL('image/png', 1);
        }
        ui.changeIconColor = changeIconColor;
        function mapInit(mapname, centerLat, centerLon, zoomLevel, hideZoomControl) {
            const mapDiv = $('#' + mapname);
            if (!mapDiv.length)
                return;
            const map = new L.Map(mapname, {
                center: new L.LatLng(centerLat, centerLon),
                minZoom: 2,
                zoom: zoomLevel,
                zoomControl: false
            });
            map.attributionControl.setPrefix(appn.emptyString);
            if (!hideZoomControl)
                L.control.zoom({ position: 'topright' }).addTo(map);
            const tileUrl = 'https://{s}.tile.thunderforest.com/appn-h2w/{z}/{x}/{y}{r}.png?apikey=9620569baf5e41caa7213c5e4812f729';
            const layer = new L.TileLayer(tileUrl, {
                attribution: '<a href="http://www.thunderforest.com">Thunderforest</a>, <a href="http://www.leafletjs.com">Leaflet</a>, <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                maxZoom: 18
            });
            map.addLayer(layer);
            layer.on("loading", function () { appn.utils.mapLoadState = "loading"; });
            layer.on("load", function () { appn.utils.mapLoadState = "loaded"; });
            return map;
        }
        ui.mapInit = mapInit;
        function validateSessionFromAjax(jqxhrResponse) {
            if (jqxhrResponse && jqxhrResponse.responseText)
                if (jqxhrResponse.responseText.indexOf('form-signin') !== -1) {
                    if ($('.bootbox').hasClass('in') && $('.bootbox').hasClass('signinrequired'))
                        return;
                    appn.dialog.alert({
                        modalColor: 'modal-info',
                        title: T('Sign In Required'),
                        className: 'signinrequired',
                        message: T('Your session has been invalidated.<br>This may have occurred because you logged into a different account in another browser tab.<br />Please Sign In to resume using the platform.'),
                        buttons: {
                            ok: {
                                label: '<span>' + T('OK') + '</span>',
                                className: 'btn-success'
                            }
                        },
                        callback: function (result) {
                            appn.location.reloadCurrentPage();
                        }
                    });
                }
        }
        ui.validateSessionFromAjax = validateSessionFromAjax;
        function spinnerInject(appenedToElement) {
            appenedToElement.append(getSpinner());
        }
        ui.spinnerInject = spinnerInject;
        function spinnerRemove(removeFromElement) {
            removeFromElement.find('.appn-spinner').remove();
        }
        ui.spinnerRemove = spinnerRemove;
        function getSpinner(classes) {
            return `<div class="appn-spinner spinner-border text-primary ${(classes ? classes : appn.emptyString)}" role="status"></div>`;
        }
        ui.getSpinner = getSpinner;
        function checkboxForceOnChanged(selector) {
            $(selector).off().on('change', function (e) {
                const isChecked = $(this).is(':checked');
                const hiddenInput = $(this).closest('.appn-checkbox').find('input[type="hidden"]');
                if (isChecked)
                    hiddenInput.prop('value', true);
                else
                    hiddenInput.prop('value', false);
            });
            $(selector).each(function (index, element) {
                const hiddenInput = $(element).closest('.appn-checkbox').find('input[type="hidden"]');
                const isValueChecked = hiddenInput.prop('value') === 'true' ? true : false;
                if (isValueChecked)
                    $(element).closest('.appn-checkbox').find('label').click();
            });
        }
        ui.checkboxForceOnChanged = checkboxForceOnChanged;
        function showTimeZoneDialog() {
            appn.dialog.custom({
                message: '<div class="form-group">' + appn.elementBuilder.buildSelect(appn.timeZones, 'timeZonesSelect', '', T('List of Time Zones')) + `<br /><label class="form-control-sm col-form-label" for="timeZoneValue">${T('Time Zone Value:')}</label><input type="text" id="timeZoneValue" class="form-control-sm form-control" name="timeZoneValue" readonly></div>`,
                title: T('List of Time Zones'),
                modalColor: 'modal-info',
                closeButton: true
            });
            $('#timeZonesSelect').off().on('change', function () {
                var _a;
                $('#timeZoneValue').val((_a = $('#timeZonesSelect').val()) !== null && _a !== void 0 ? _a : appn.emptyString);
            });
        }
        ui.showTimeZoneDialog = showTimeZoneDialog;
        function initCardSummaries() {
            if ($('.summary-field').length <= 0)
                return;
            $('.card.collapsed-card:has(.summary-field)').each(function () {
                let $card = $(this);
                let $summaryContainer = buildCardSummary($card);
                $summaryContainer.show();
            });
            $('.card:has(.card-body .summary-field)')
                .on('expanded.lte.cardwidget', function () {
                let $card = $(this);
                $card.find('.card-summary').slideUp(300);
            })
                .on('collapsed.lte.cardwidget', function () {
                let $card = $(this);
                let $summaryContainer = buildCardSummary($card);
                $summaryContainer.slideDown(300);
            });
        }
        ui.initCardSummaries = initCardSummaries;
        function buildCardSummary($card) {
            let $header = $card.find('.card-header');
            if ($header.find('.card-summary').length === 0) {
                $header.addClass('flex-wrap');
                const $summary = $('<div class="card-summary w-100 mt-2" style="display: none;"></div>');
                $summary.on('click', function () {
                    $(this).closest('.card')
                        .find('[data-card-widget="collapse"]')
                        .trigger('click');
                });
                $header.append($summary);
            }
            let $summaryContainer = $card.find('.card-summary');
            $summaryContainer.empty();
            $card.find('.summary-field').each(function () {
                let $summaryRow = $('<div class="form-group row mb-0"></div>');
                $(this).find('label.col-form-label').each(function () {
                    let $originalLabel = $(this);
                    let labelClasses = $originalLabel.attr('class');
                    let cleanLabelText = $originalLabel.text().trim();
                    let inputId = $originalLabel.attr('for');
                    let $input = $('#' + inputId);
                    if ($input.length > 0) {
                        let wrapperClasses = $input.closest('[class*="col-"]').attr('class') || 'col-md-9';
                        let value = '';
                        if ($input.is('select')) {
                            value = $input.find('option:selected').text();
                        }
                        else {
                            value = $input.val() || '-';
                        }
                        $summaryRow.append(`
                        <label class="${labelClasses} mb-0">${cleanLabelText}</label>
                        <div class="${wrapperClasses}">
                            <div class="form-control-plaintext font-weight-bold text-dark mb-0">${value}</div>
                        </div>
                    `);
                    }
                });
                $summaryContainer.append($summaryRow);
            });
            return $summaryContainer;
        }
        function initCountryStateDropdown(options) {
            const $country = $(options.countrySelector);
            const $stateText = $(options.stateTextSelector);
            const $stateSelect = $(options.stateSelectSelector);
            if (!$country.length || !$stateText.length || !$stateSelect.length || !options.countryStates)
                return;
            $stateText.addClass('validate-always');
            function updateStateField(isInit = false) {
                const countryCode = ($country.val() || '').toUpperCase();
                const states = options.countryStates[countryCode];
                appn.select.destroy(options.stateSelectSelector);
                if (states) {
                    $stateText.hideElement();
                    $stateSelect.removeAttr('name').empty().append($('<option>', { value: '', text: T('Choose...') }));
                    $.each(states, (code, name) => $stateSelect.append($('<option>', { value: code, text: name })));
                    if (isInit) {
                        const currentState = $stateText.val();
                        if (currentState) {
                            const code = states[currentState] ? currentState : Object.keys(states).find(k => k.toLowerCase() === currentState.toLowerCase() || states[k].toLowerCase() === currentState.toLowerCase());
                            if (code)
                                $stateSelect.val(code);
                        }
                    }
                    else {
                        $stateText.val('');
                        $stateSelect.val('');
                    }
                    $stateSelect.removeClass('d-none').removeAttr('data-oldclasses');
                    appn.select.init({ selector: options.stateSelectSelector });
                    $stateSelect.showElement().next('.select2').showElement();
                }
                else {
                    $stateSelect.hideElement().next('.select2').hideElement();
                    $stateText.showElement();
                    if (!isInit)
                        $stateText.val('');
                }
                syncValidationStyling();
            }
            function syncValidationStyling() {
                const hasError = $stateText.hasClass('input-validation-error');
                $stateSelect.toggleClass('is-invalid', hasError);
                const $select2 = $stateSelect.next('.select2');
                if ($select2.length) {
                    $select2.removeClass('input-validation-error');
                }
            }
            $country.on('change', () => updateStateField());
            $stateSelect.on('change', () => {
                if ($stateSelect.is(':visible')) {
                    $stateText.val($stateSelect.val());
                    if ($stateText.valid)
                        $stateText.valid();
                }
                syncValidationStyling();
            });
            const observer = new MutationObserver(() => syncValidationStyling());
            observer.observe($stateText[0], { attributes: true, attributeFilter: ['class'] });
            updateStateField(true);
        }
        ui.initCountryStateDropdown = initCountryStateDropdown;
        function initTriStateCheckboxes(container) {
            const $wrappers = $(container || document).find('.appn-checkbox.tristate');
            $wrappers.each(function () {
                const $wrapper = $(this);
                const $checkbox = $wrapper.find('input[type="checkbox"]');
                const $hidden = $wrapper.find('input[type="hidden"]');
                const $label = $wrapper.find('label');
                if (!$checkbox.length || !$hidden.length || !$label.length)
                    return;
                const hiddenVal = $hidden.val();
                if (hiddenVal === '')
                    $checkbox[0].indeterminate = true;
                $label.off('click').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const checkbox = $checkbox[0];
                    const hidden = $hidden[0];
                    if (checkbox.indeterminate) {
                        checkbox.indeterminate = false;
                        checkbox.checked = true;
                        hidden.value = 'true';
                    }
                    else if (checkbox.checked) {
                        checkbox.indeterminate = false;
                        checkbox.checked = false;
                        hidden.value = 'false';
                    }
                    else {
                        checkbox.indeterminate = true;
                        checkbox.checked = false;
                        hidden.value = '';
                    }
                });
            });
        }
        ui.initTriStateCheckboxes = initTriStateCheckboxes;
    })(ui = appn.ui || (appn.ui = {}));
})(appn || (appn = {}));
